import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import { Link, useNavigate  } from 'react-router-dom'
import { schoolsurl } from '../../apis/urls';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup'

const AddSchools = () =>{

    const [errorName, setErrorName] = useState({message:'pending'});
    const [errorEmail, setErrorEmail] = useState({message:'pending'});

    const validationSchema = yup.object({
        name: yup
            .string('Enter schoo name')
            .required('School name is required'),
        address_1: yup
            .string('Enter address')
            .required('Address is required'),
        city: yup
            .string('Enter city')
            .required('City is required'),
        state: yup
            .string('Enter state')
            .required('State is required'),
        zip: yup
            .string('Enter zip')
            .required('Zip is required'),
        email: yup
            .string('Enter email')
            .email('Enter a valid email')
            .required('Email is required'),
        phone: yup
            .string('Enter phone')
            .required('Phone is required'),
    })


    let navigate = useNavigate();
    const RoutToList = () =>{
        let path = 'newPath'; 
        navigate("/school_list")
    }

    const { register, reset, control, handleSubmit, formState:{ errors }, setValue} = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        
            let token = "Bearer "+localStorage.getItem('token');
        
            const dataValues = {
                name :data.name,
                address_1 :data.address_1,
                address_2:data.address_2,
                city:data.city,
                state :data.state,  
                zip:data.zip, 
                email:data.email,
                phone:data.phone,
                fax:data.fax,
                website:data.website,
                status:"ACTIVE",
            }

            const instance = axios.create({
                baseURL: schoolsurl,
                timeout: 1000000,
                headers: {'authorization': token}
            });


            instance.post('', dataValues).then(res => {
                navigate("/school_list")
            }).catch(err => {
                console.log(err?.response?.data?.error?.length)
            });   
        
    }

    const validation = (type, text) => {
           
        const data = {
            type: type,
            text: text,
        }

        const instance = axios.create({
            baseURL: `${schoolsurl}/validation/exist/check`,
            timeout: 1000000
        });

        instance.post('', data).then(res => {
            if(type === 'email'){
                setErrorEmail(res.data)
            }

            if(type === 'name'){
                setErrorName(res.data)
            }
        }).catch(err => {
            console.log(err)
        });   
    
    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
            <div className="content-area">
            <div className="page-title-wrpr">
                <div className="page-title-left-column">  
                    <h2 className="page-title">Add Schools</h2>
                </div>
                <div className="page-rightside-action-column">
                </div>
            </div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/school_list">Schools List</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Schools</li>
              </ol>
            </nav>

            <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
                <div className="form-wrpr">
                    <div className="card formcard medium">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                        {
                                            (errorName?.message === 'pending' && !errors?.name?.message) ?
                                            <i className="icon-notice1 iconemail-pending"></i> :
                                            (errorName?.message === 'failed' && !errors?.name?.message) ?
                                            <i className="icon-checkmark3 iconemail-valid"></i> : 
                                            (errorName?.message === 'success' || errors?.name?.message) ?
                                            <i className="icon-cancel2 iconemail-invalid"></i> : null
                                        }
                                        <input
                                        {...register('name', {
                                            onChange: (e) => {validation('name', e.target.value)},
                                            onBlur: (e) => {},
                                        })}
                                        name="name" 
                                        type="text" 
                                        className="form-control bg-dark dark-theme showtext" 
                                        id="name" />
                                        <div className="error-school">{errors?.name?.message}</div>
                                        <div className="error-school">{errorName?.message === 'success' && "School Name Already Exist"}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Address 1 <span style={{color: "red"}}>*</span></label>
                                        <input {...register('address_1')} name="address_1" type="text" className="form-control bg-dark dark-theme showtext" id="name" />
                                        <div className="error-school">{errors?.address_1?.message}</div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Address 2</label>
                                        <input {...register('address_2')} name="address_1" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">City <span style={{color: "red"}}>*</span></label>
                                        <input {...register('city')} name="city" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                        <div className="error-school">{errors?.city?.message}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">State <span style={{color: "red"}}>*</span></label>
                                        <input {...register('state')} name="state" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                        <div className="error-school">{errors?.state?.message}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Zip Code <span style={{color: "red"}}>*</span></label>
                                        <input {...register('zip')} name="zip" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                        <div className="error-school">{errors?.zip?.message}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Phone No <span style={{color: "red"}}>*</span></label>
                                        <input {...register('phone')} name="phone" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                        <div className="error-school">{errors?.phone?.message}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Fax</label>
                                        <input {...register('fax')} name="fax" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Website</label>
                                        <input {...register('website')} name="website" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="degreehead">Email <span style={{color: "red"}}>*</span></label>
                                        {
                                            (errorEmail?.message === 'pending' && !errors?.email?.message) ?
                                            <i className="icon-notice1 iconemail-pending"></i> :
                                            (errorEmail?.message === 'failed' && !errors?.email?.message) ?
                                            <i className="icon-checkmark3 iconemail-valid"></i> : 
                                            (errorEmail?.message === 'success' || errors?.email?.message) ?
                                            <i className="icon-cancel2 iconemail-invalid"></i> : null
                                        }
                                        <input 
                                        {...register('email', {
                                            onChange: (e) => {validation('email', e.target.value)},
                                            onBlur: (e) => {},
                                        })}
                                        name="email" 
                                        type="text" 
                                        className="form-control bg-dark dark-theme showtext" 
                                        id="name"
                                        />
                                        <div className="error-school">{errors?.email?.message}</div>
                                        <div className="error-school">
                                            {errorEmail?.message === "success" && "Email already exist"}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <h6 style={{color: "red"}}>* Required Fields</h6>   
                                </div>                                     
                                    

                                <div className="col-md-6">
                                    <div className="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button className="btn btn-primary btn-gisa" type="submit">Create</button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </form>
            
        </div>
            </aside>
        </div>
    )
}

export default AddSchools;




